import { css } from "lit-element";

// language=CSS
export const style = css`
	:host {
		display: block;
		width: 100%;
	}

	.label {
		cursor: pointer;
        width: 100%;
        display: block;
	}
    .label sw-icon {
        display: none;
        --sw-icon-height: 10px;
        margin: 20px;
    }
    
    .label:hover sw-icon {
        display: block;
    }
	
    :host .filter-query-container {
		display: none;
		padding: 40px;
		position: absolute;
		z-index: 9;
		top: 100%;
		right: 0;
		left: 0;
		min-height: 150px;
		background-color: var(--app-white);

		box-shadow: 0 2px 16px var(--shadow-color, rgba(0, 0, 0, 0.15));
	}

	:host .filter-query-container[visible] {
		display: flex;
	}

	.input-simple > input {
		border: 1px solid var(--app-lightgrey);
	}

	.input-checkbox {
		width: 100%;
		display: block;
	}

	:host .filter-background {
		display: none;
		position: fixed;
		z-index: 8;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	:host .filter-background[visible] {
		display: block;
	}
`;
